import { FC, useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { ContentState, EditorState } from "draft-js";
import style from "./style.module.scss";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import htmlToDraft from "html-to-draftjs";

const fonts = [
  "Arial",
  "Georgia",
  "Impact",
  "Tahoma",
  "Times New Roman",
  "Helvetica",
  "Calibri",
  "Futura",
  "Roboto",
  "Garamond",
  "Verdana",
  "Proxima Nova",
].sort();

const options = {
  options: [
    "inline",
    "blockType",
    "fontSize",
    "fontFamily",
    "list",
    "textAlign",
    "colorPicker",
    "link",
    "embedded",
    "emoji",
    // "image",
    "remove",
    "history",
  ],
  fontFamily: {
    options: fonts,
  },
};

export interface RichTextViewerProps {
  onChange?: (content: EditorState) => void;
  initialState?: string;
  readonly?: boolean;
}

export const RichTextEditor: FC<RichTextViewerProps> = ({
  initialState,
  onChange,
  readonly = false,
}) => {
  const [editorState, setEditorState] = useState<EditorState | undefined>(
    undefined
  );

  const handleEditorStateChange = (editorState: any) => {
    setEditorState(editorState);
    onChange && onChange(editorState);
  };

  useEffect(() => {
    const blocksFromHtml = htmlToDraft(initialState || "");
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );

    setEditorState(
      initialState ? EditorState.createWithContent(contentState) : undefined
    );
  }, [initialState]);

  return (
    <Editor
      editorClassName={style.editor}
      wrapperClassName={style.editorContainer}
      toolbarClassName={style.toolbar}
      toolbar={options}
      toolbarHidden={readonly}
      readOnly={readonly}
      editorState={editorState}
      onEditorStateChange={handleEditorStateChange}
    />
  );
};
